import { useProjectApi } from "~/api/GeneratedApi";
import { useCustomMutation } from "~/utils/hooks/useCustomMutation";
import { useProjectDetails } from "../../hooks/useProjectDetails";

export const useWPR = () => {
  const { generateWPR } = useProjectApi();
  const { id } = useProjectDetails();

  const { mutateAsync } = useCustomMutation(
    ({
      base64Url,
      templateNodeId,
    }: {
      base64Url: string;
      templateNodeId: number;
    }) => {
      const baseResult = base64Url.split(",")[1];
      const createWpr = { mapImage: baseResult, templateNodeId };
      return generateWPR(createWpr, id);
    },
  );

  return { mutateAsync };
};
